<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommercialDashboardStore } from '@/stores/useCommercialDashboardStore'
import QuoteBillingTable from '@/components/features/quote-billing/QuoteBillingTable.vue'

const store = useCommercialDashboardStore()
const { myQuoteBillingRows, myQuoteBillingLoading, myQuoteBillingError } = storeToRefs(store)

const search = ref('')
const statusFilter = ref('')

const STATUS_OPTIONS = [
  { value: '', label: 'Tous les statuts' },
  { value: 'NOT_INVOICED', label: 'Non facturé' },
  { value: 'PARTIALLY_INVOICED', label: 'Partiellement facturé' },
  { value: 'INVOICED', label: 'Facturé' },
  { value: 'UNPAID', label: 'Non payé' },
  { value: 'PARTIALLY_PAID', label: 'Partiellement payé' },
  { value: 'PAID', label: 'Payé' },
]

function refresh() {
  store.fetchMyQuoteBilling({ search: search.value || undefined, status: statusFilter.value || undefined })
}

let searchTimeout: ReturnType<typeof setTimeout> | undefined
function debouncedRefresh() {
  if (searchTimeout) clearTimeout(searchTimeout)
  searchTimeout = setTimeout(refresh, 400)
}

watch(search, debouncedRefresh)
watch(statusFilter, refresh)

onMounted(refresh)
</script>

<template>
  <div class="card bg-base-100 shadow">
    <div class="card-body p-0">
      <div class="flex flex-col gap-3 px-5 py-4 border-b border-base-200 lg:flex-row lg:items-center lg:justify-between">
        <h2 class="card-title text-base">
          Mes devis & factures
          <span class="text-sm font-normal opacity-50">({{ myQuoteBillingRows.length }})</span>
        </h2>
        <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
          <input
            v-model="search"
            type="text"
            placeholder="Réf. devis, réf. client, société…"
            class="input input-sm input-bordered w-full sm:w-64"
          />
          <select v-model="statusFilter" class="select select-sm select-bordered">
            <option v-for="opt in STATUS_OPTIONS" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
        </div>
      </div>

      <div v-if="myQuoteBillingLoading" class="flex justify-center py-12">
        <span class="loading loading-spinner loading-lg text-primary"></span>
      </div>

      <div v-else-if="myQuoteBillingError" class="alert alert-error m-5">
        <span class="text-sm">{{ myQuoteBillingError }}</span>
      </div>

      <div v-else class="p-5 pt-0">
        <QuoteBillingTable :rows="myQuoteBillingRows" />
      </div>
    </div>
  </div>
</template>
